// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"project-story-footer-m__wrapper__QxkN5"};